import Vue from 'vue'

Vue.mixin({
  methods: {
    /**
     * Show notification
     *
     * @param {string} text
     * @param {'positive'|'negative'|'primary'} type
     * @param timeout
     */
    notify(text, type = 'primary', timeout = 3000){
      this.$q.notify({
        message: text,
        type: type,
        color: type,
        timeout: timeout
      })
    },
    openLink(link) {
      if(typeof cordova === "undefined"){
        return window.open(link, '_blank')
      }

      cordova.plugins.OpenInSafari.open(link);
    },
    notifyOffline(){
      this.notify("You are currently offline and info can't be loaded.", 'negative')
    },
    axiosGet(uri, successCallback, loading = true, errorCallback){
      if(loading){
        this.$q.loading.show()
      }

      let promise = this.$axios.get(this.$apiUrl + uri);

      if(typeof successCallback === "function"){
        promise.then(successCallback);
      }

      if(typeof errorCallback === "function"){
        promise.catch(errorCallback)
      }

      promise.finally((r) => {
        if(loading){
          this.$q.loading.hide()
        }
      })

      return promise
    },

    axiosPost(uri, data, successCallback, loading = true, errorCallback){
      if(loading){
        this.$q.loading.show()
      }

      let promise = this.$axios.post(this.$apiUrl + uri, data);

      if(typeof successCallback === "function"){
        promise.then(successCallback);
      }

      if(typeof errorCallback === "function"){
        promise.catch(errorCallback)
      }

      promise.finally(() => {
        if(loading){
          this.$q.loading.hide()
        }
      })

      return promise
    },
    getCart(){
      this.axiosGet('/cart', (r) => {
        this.$store.commit('mainStore/cart', r.data)
      }, false)
    },
    syncUser(loading = true) {
      return this.$axiosNoIntercept.get(this.$apiUrl + '/user/me').then((r) => {
        this.$store.commit('mainStore/user', r.data)
      })
    },
  },
  computed: {
    isCordova(){
      return typeof cordova != "undefined"
    },

    online(){
      if (typeof Connection === "undefined" || typeof cordova === "undefined"){
        // in browser
        return true
      }

      return /* this.$store.state.mainStore.online || */[
        // eslint-disable-next-line no-undef
        Connection.NONE,
        // eslint-disable-next-line no-undef
        Connection.UNKNOWN
      ].indexOf(navigator.connection.type) === -1
    },
    requiredRules(){
      return [v => !!v || 'Value is required']
    },
    paymentsEnabled: {
      get(){
        return this.$store.state.mainStore.paymentsEnabled
      },
      set(v){
        this.$store.commit('mainStore/paymentsEnabled', v)
      },
    },
    currentUser(){
      try {
        return this.$store.state.mainStore.user || {}
      } catch {
        return {}
      }
    }
  }
})
